module.exports = __webpack_public_path__ + "static/media/teacher21.13e27f15.png";